// set user system permissions
export const setUserSystemPermissions = (store, data) => {
    store.userSystemPermissions = data || {};
};

// set user permissions for current application
export const setCurrentAppUserPermissions = (store, data) => {
    store.currentAppUserPermissions = data || {};
};
